import React, { Fragment, useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import HeaderEjercicios from '../../../AuxiliaresPaginas/HeaderEjercicios';
import Instrucciones from '../../../Escritorio/Instrucciones';

import useConfigAuth from '../../../../Hooks/useConfigAuth';

import BotoneraBottom from '../../Compartidos/BotoneraBottom';

import {
    finalizarEjercicioAction,
    setearEjercicioAction,
    setearUrlAnteriorAction
} from '../../../../actions/estadoEjercicioActions';

import { almacenarAction } from '../../../../actions/almacenarEjercicioActions';

import { ContainerFlex } from '../../../Css/MetodosCSS/StyledLN2Todos';

import {
    AvanzarImg,
    AvanzarBtn,
    PantallaM155,
    ContenidoM155,
    NumeroObjetivoM155,
    ZonaTrabajoM155,
    ActividadM155,
    EscenaM155,
    BottomM155
} from '../../../Css/StyledMatematica';


// ============================================================================
// CONFIGURACIÓN
// ============================================================================

const CANTIDAD_EJERCICIOS = 3;

const MAX_PARTES = 12;

const ACCENT = '#23AAAF';
const MARK = '#E8662B';
const OK = '#2E8B57';
const INK = '#222222';
const PINTADO = '#F2A541';


const miniInstrucciones =
    'Representá el número, escribilo de la otra manera y ubicalo en la recta numérica.';


// ============================================================================
// BANCO
//
// a_mixto:
// mostramos fracción impropia → responde número mixto.
//
// a_fraccion:
// mostramos número mixto → responde fracción impropia.
// ============================================================================

const NUMEROS = [

    {
        modo: 'a_mixto',
        num: 15,
        den: 4
    },

    {
        modo: 'a_mixto',
        num: 7,
        den: 2
    },

    {
        modo: 'a_mixto',
        num: 5,
        den: 3
    },

    {
        modo: 'a_mixto',
        num: 9,
        den: 4
    },

    {
        modo: 'a_mixto',
        num: 11,
        den: 3
    },

    {
        modo: 'a_mixto',
        num: 13,
        den: 5
    },

    {
        modo: 'a_mixto',
        num: 17,
        den: 6
    },

    {
        modo: 'a_mixto',
        num: 9,
        den: 2
    },

    {
        modo: 'a_mixto',
        num: 19,
        den: 4
    },

    {
        modo: 'a_mixto',
        num: 10,
        den: 3
    },

    {
        modo: 'a_fraccion',
        num: 7,
        den: 3
    },

    {
        modo: 'a_fraccion',
        num: 7,
        den: 4
    },

    {
        modo: 'a_fraccion',
        num: 7,
        den: 2
    },

    {
        modo: 'a_fraccion',
        num: 12,
        den: 5
    },

    {
        modo: 'a_fraccion',
        num: 17,
        den: 4
    },

    {
        modo: 'a_fraccion',
        num: 11,
        den: 6
    }

];


// ============================================================================
// AUXILIARES
// ============================================================================

const range = (
    cantidad
) => {

    return Array.from(
        {
            length: cantidad
        },
        (_, index) => index
    );
};


const cursor = (
    activo
) => ({
    cursor:
        activo
            ? 'pointer'
            : 'default'
});


const mezclar = (
    array
) => {

    const copia = [
        ...array
    ];


    for (
        let i = copia.length - 1;
        i > 0;
        i--
    ) {

        const j =
            Math.floor(
                Math.random() *
                (
                    i + 1
                )
            );


        [
            copia[i],
            copia[j]
        ] = [
            copia[j],
            copia[i]
        ];
    }


    return copia;
};


// ============================================================================
// SELECCIONAR 3
//
// Garantizamos que aparezcan las dos transformaciones.
// ============================================================================

const seleccionarEjercicios = () => {

    const aMixto =
        mezclar(
            NUMEROS.filter(
                item =>
                    item.modo ===
                    'a_mixto'
            )
        );


    const aFraccion =
        mezclar(
            NUMEROS.filter(
                item =>
                    item.modo ===
                    'a_fraccion'
            )
        );


    const seleccionInicial = [

        aMixto[0],

        aFraccion[0]

    ];


    const usados =
        new Set(
            seleccionInicial.map(
                item =>
                    `${item.modo}-${item.num}-${item.den}`
            )
        );


    const restantes =
        mezclar(
            NUMEROS.filter(
                item =>

                    !usados.has(
                        `${item.modo}-${item.num}-${item.den}`
                    )
            )
        );


    seleccionInicial.push(
        restantes[0]
    );


    return mezclar(
        seleccionInicial
    )
        .slice(
            0,
            CANTIDAD_EJERCICIOS
        );
};


// ============================================================================
// NÚMERO
// ============================================================================

const Numero = ({
    e = 0,
    num,
    den,
    size = 64,
    color = INK
}) => {

    const fraccion =
        size *
        0.6;


    return (

        <div
            style={{
                display:
                    'inline-flex',

                alignItems:
                    'center',

                justifyContent:
                    'center',

                gap:
                    size *
                    0.18,

                fontFamily:
                    'Nunito',

                fontWeight:
                    800,

                color,

                lineHeight:
                    1
            }}
        >

            {
                e > 0 && (

                    <span
                        style={{
                            fontSize:
                                size
                        }}
                    >
                        {e}
                    </span>
                )
            }


            {
                num > 0 && (

                    <span
                        style={{
                            display:
                                'inline-flex',

                            flexDirection:
                                'column',

                            alignItems:
                                'center'
                        }}
                    >

                        <span
                            style={{
                                fontSize:
                                    fraccion
                            }}
                        >
                            {num}
                        </span>


                        <span
                            style={{
                                width:
                                    fraccion *
                                    1.3,

                                height:
                                    Math.max(
                                        3,
                                        size /
                                        16
                                    ),

                                background:
                                    color,

                                borderRadius:
                                    2,

                                margin:
                                    `${size * 0.06}px 0`
                            }}
                        />


                        <span
                            style={{
                                fontSize:
                                    fraccion
                            }}
                        >
                            {den}
                        </span>

                    </span>
                )
            }

        </div>
    );
};


// ============================================================================
// BOTONES
// ============================================================================

const boton = {

    fontFamily:
        'Nunito',

    fontSize:
        17,

    fontWeight:
        600,

    padding:
        '8px 16px',

    borderRadius:
        12,

    border:
        `2px solid ${ACCENT}`,

    background:
        '#FFFFFF',

    color:
        ACCENT,

    cursor:
        'pointer'
};


const botonPequeno = {

    ...boton,

    padding:
        '4px 14px',

    fontSize:
        22,

    lineHeight:
        1
};


// ============================================================================
// PARTIR
// ============================================================================

const Partir = ({
    valor,
    onCambio,
    disabled,
    texto = 'Partir en:'
}) => {

    return (

        <div
            style={{
                display:
                    'flex',

                alignItems:
                    'center',

                justifyContent:
                    'center',

                gap:
                    12,

                fontFamily:
                    'Nunito',

                fontSize:
                    19,

                fontWeight:
                    700
            }}
        >

            <span>
                {texto}
            </span>


            <button
                type="button"
                style={{
                    ...botonPequeno,

                    opacity:
                        disabled ||
                        valor <= 1

                            ? 0.4
                            : 1,

                    cursor:
                        disabled ||
                        valor <= 1

                            ? 'default'
                            : 'pointer'
                }}
                disabled={
                    disabled ||
                    valor <= 1
                }
                onClick={() =>
                    onCambio(
                        valor -
                        1
                    )
                }
            >
                −
            </button>


            <span
                style={{
                    minWidth:
                        30,

                    textAlign:
                        'center',

                    fontSize:
                        26
                }}
            >
                {valor}
            </span>


            <button
                type="button"
                style={{
                    ...botonPequeno,

                    opacity:
                        disabled ||
                        valor >= MAX_PARTES

                            ? 0.4
                            : 1,

                    cursor:
                        disabled ||
                        valor >= MAX_PARTES

                            ? 'default'
                            : 'pointer'
                }}
                disabled={
                    disabled ||
                    valor >= MAX_PARTES
                }
                onClick={() =>
                    onCambio(
                        valor +
                        1
                    )
                }
            >
                +
            </button>

        </div>
    );
};


// ============================================================================
// CONTADOR
// ============================================================================

const Contador = ({
    valor,
    onCambio,
    min,
    disabled,
    etiqueta,
    vertical = false
}) => {


    const restar = () => {

        if (
            disabled
        ) {

            return;
        }


        onCambio(

            valor === null

                ? min

                : Math.max(
                    min,
                    valor - 1
                )
        );
    };


    const sumar = () => {

        if (
            disabled
        ) {

            return;
        }


        onCambio(

            valor === null

                ? Math.max(
                    min,
                    1
                )

                : Math.min(
                    40,
                    valor + 1
                )
        );
    };


    const menos = (

        <button
            type="button"
            style={{
                ...botonPequeno,

                opacity:
                    disabled
                        ? 0.4
                        : 1
            }}
            disabled={
                disabled
            }
            aria-label={
                `Restar ${etiqueta}`
            }
            onClick={
                restar
            }
        >
            −
        </button>
    );


    const mas = (

        <button
            type="button"
            style={{
                ...botonPequeno,

                opacity:
                    disabled
                        ? 0.4
                        : 1
            }}
            disabled={
                disabled
            }
            aria-label={
                `Sumar ${etiqueta}`
            }
            onClick={
                sumar
            }
        >
            +
        </button>
    );


    return (

        <div
            style={{
                display:
                    'flex',

                flexDirection:
                    vertical
                        ? 'column'
                        : 'row',

                alignItems:
                    'center',

                gap:
                    vertical
                        ? 8
                        : 12
            }}
        >

            {
                vertical
                    ? mas
                    : menos
            }


            <div
                style={{
                    width:
                        56,

                    height:
                        56,

                    border:
                        `3px solid ${INK}`,

                    borderRadius:
                        10,

                    display:
                        'flex',

                    alignItems:
                        'center',

                    justifyContent:
                        'center',

                    fontFamily:
                        'Nunito',

                    fontSize:
                        30,

                    fontWeight:
                        700,

                    color:
                        valor === null

                            ? '#AAAAAA'
                            : INK
                }}
            >
                {
                    valor === null
                        ? '?'
                        : valor
                }
            </div>


            {
                vertical
                    ? menos
                    : mas
            }

        </div>
    );
};


// ============================================================================
// BANDEJAS
// ============================================================================

const Bandejas = ({
    cantidad,
    partes,
    pintadas,
    onTocar,
    activo
}) => {

    const width =
        200;

    const height =
        64;


    if (
        cantidad === 0
    ) {

        return null;
    }


    return (

        <div
            style={{
                width:
                    '100%',

                display:
                    'flex',

                flexWrap:
                    'wrap',

                gap:
                    12,

                justifyContent:
                    'center',

                alignItems:
                    'center'
            }}
        >

            {
                range(
                    cantidad
                )
                    .map(
                        bandeja => {

                            const llena =
                                partes > 0 &&
                                range(
                                    partes
                                )
                                    .every(
                                        parte =>
                                            pintadas[
                                                bandeja *
                                                partes +
                                                parte
                                            ]
                                    );


                            return (

                                <svg
                                    key={
                                        bandeja
                                    }
                                    viewBox={
                                        `0 0 ${width + 8} ${height + 8}`
                                    }
                                    style={{
                                        width:
                                            208,

                                        maxWidth:
                                            '100%',

                                        height:
                                            'auto',

                                        display:
                                            'block'
                                    }}
                                    role="img"
                                    aria-label={
                                        `Bandeja ${bandeja + 1}`
                                    }
                                >

                                    {
                                        range(
                                            partes
                                        )
                                            .map(
                                                parte => (

                                                    <rect
                                                        key={
                                                            parte
                                                        }
                                                        x={
                                                            4 +
                                                            (
                                                                parte *
                                                                width
                                                            ) /
                                                            partes
                                                        }
                                                        y={
                                                            4
                                                        }
                                                        width={
                                                            width /
                                                            partes
                                                        }
                                                        height={
                                                            height
                                                        }
                                                        fill={
                                                            pintadas[
                                                                bandeja *
                                                                partes +
                                                                parte
                                                            ]

                                                                ? PINTADO
                                                                : '#F4F1EC'
                                                        }
                                                        stroke="#333333"
                                                        strokeWidth={
                                                            2
                                                        }
                                                        style={
                                                            cursor(
                                                                activo
                                                            )
                                                        }
                                                        onClick={() => {

                                                            if (
                                                                activo
                                                            ) {

                                                                onTocar(
                                                                    bandeja,
                                                                    parte
                                                                );
                                                            }
                                                        }}
                                                    />
                                                )
                                            )
                                    }


                                    <rect
                                        x={
                                            4
                                        }
                                        y={
                                            4
                                        }
                                        width={
                                            width
                                        }
                                        height={
                                            height
                                        }
                                        rx={
                                            3
                                        }
                                        fill="none"
                                        stroke={
                                            llena
                                                ? OK
                                                : '#333333'
                                        }
                                        strokeWidth={
                                            llena
                                                ? 5
                                                : 3.5
                                        }
                                        pointerEvents="none"
                                    />

                                </svg>
                            );
                        }
                    )
            }

        </div>
    );
};


// ============================================================================
// RECTA NUMÉRICA
// ============================================================================

const Recta = ({
    limite,
    cantidadBandejas,
    partes,
    pintadas,
    marca,
    onTocarParte,
    onClicRecta,
    done,
    valorMostrar
}) => {

    const X0 = 70;

    const UNIT =
        Math.min(
            170,
            820 /
            limite
        );

    const Y = 170;

    const W =
        X0 *
        2 +
        UNIT *
        limite;

    const H =
        260;

    const TY =
        Y -
        66;

    const TH =
        46;


    const toX = (
        numero
    ) =>

        X0 +
        numero *
        UNIT;


    const clic = (
        e
    ) => {

        if (
            done
        ) {

            return;
        }


        const svg =
            e.currentTarget
                .ownerSVGElement;


        if (
            !svg
        ) {

            return;
        }


        const pt =
            svg.createSVGPoint();


        pt.x =
            e.clientX;

        pt.y =
            e.clientY;


        const matrix =
            svg.getScreenCTM();


        if (
            !matrix
        ) {

            return;
        }


        const local =
            pt.matrixTransform(
                matrix.inverse()
            );


        onClicRecta(
            Math.max(
                0,
                Math.min(
                    limite,
                    (
                        local.x -
                        X0
                    ) /
                    UNIT
                )
            )
        );
    };


    return (

        <svg
            viewBox={
                `0 0 ${W} ${H}`
            }
            style={{
                width:
                    '100%',

                maxWidth:
                    W,

                height:
                    'auto',

                display:
                    'block',

                userSelect:
                    'none'
            }}
            role="img"
            aria-label="Recta numérica"
        >

            <line
                x1={
                    toX(
                        0
                    ) -
                    45
                }
                y1={
                    Y
                }
                x2={
                    toX(
                        limite
                    ) +
                    45
                }
                y2={
                    Y
                }
                stroke={
                    INK
                }
                strokeWidth={
                    3
                }
            />


            <polygon
                points={
                    `${toX(0) - 58},${Y} ${toX(0) - 43},${Y - 9} ${toX(0) - 43},${Y + 9}`
                }
                fill={
                    INK
                }
            />


            <polygon
                points={
                    `${toX(limite) + 58},${Y} ${toX(limite) + 43},${Y - 9} ${toX(limite) + 43},${Y + 9}`
                }
                fill={
                    INK
                }
            />


            {
                range(
                    limite +
                    1
                )
                    .map(
                        numero => (

                            <g
                                key={
                                    numero
                                }
                            >

                                <line
                                    x1={
                                        toX(
                                            numero
                                        )
                                    }
                                    y1={
                                        Y -
                                        12
                                    }
                                    x2={
                                        toX(
                                            numero
                                        )
                                    }
                                    y2={
                                        Y +
                                        12
                                    }
                                    stroke={
                                        INK
                                    }
                                    strokeWidth={
                                        3
                                    }
                                />


                                <text
                                    x={
                                        toX(
                                            numero
                                        )
                                    }
                                    y={
                                        Y +
                                        40
                                    }
                                    textAnchor="middle"
                                    fontSize="22"
                                    fontWeight="600"
                                    fill={
                                        INK
                                    }
                                >
                                    {
                                        numero
                                    }
                                </text>

                            </g>
                        )
                    )
            }


            <rect
                x={
                    toX(
                        0
                    ) -
                    20
                }
                y={
                    Y -
                    14
                }
                width={
                    UNIT *
                    limite +
                    40
                }
                height={
                    60
                }
                fill="transparent"
                style={
                    cursor(
                        !done
                    )
                }
                onClick={
                    done
                        ? undefined
                        : clic
                }
            />


            {
                cantidadBandejas > 0 &&

                range(
                    cantidadBandejas
                )
                    .map(
                        bandeja => (

                            <g
                                key={
                                    bandeja
                                }
                            >

                                {
                                    range(
                                        partes
                                    )
                                        .map(
                                            parte => (

                                                <rect
                                                    key={
                                                        parte
                                                    }
                                                    x={
                                                        toX(
                                                            bandeja
                                                        ) +
                                                        (
                                                            parte *
                                                            UNIT
                                                        ) /
                                                        partes
                                                    }
                                                    y={
                                                        TY
                                                    }
                                                    width={
                                                        UNIT /
                                                        partes
                                                    }
                                                    height={
                                                        TH
                                                    }
                                                    fill={
                                                        pintadas[
                                                            bandeja *
                                                            partes +
                                                            parte
                                                        ]

                                                            ? PINTADO
                                                            : '#F4F1EC'
                                                    }
                                                    stroke="#333333"
                                                    strokeWidth={
                                                        2
                                                    }
                                                    style={
                                                        cursor(
                                                            !done
                                                        )
                                                    }
                                                    onClick={() => {

                                                        if (
                                                            !done
                                                        ) {

                                                            onTocarParte(
                                                                bandeja,
                                                                parte
                                                            );
                                                        }
                                                    }}
                                                />
                                            )
                                        )
                                }


                                <rect
                                    x={
                                        toX(
                                            bandeja
                                        )
                                    }
                                    y={
                                        TY
                                    }
                                    width={
                                        UNIT
                                    }
                                    height={
                                        TH
                                    }
                                    fill="none"
                                    stroke="#333333"
                                    strokeWidth={
                                        3
                                    }
                                    rx={
                                        3
                                    }
                                    pointerEvents="none"
                                />

                            </g>
                        )
                    )
            }


            {
                marca !== null && (

                    <g
                        pointerEvents="none"
                    >

                        <circle
                            cx={
                                toX(
                                    marca
                                )
                            }
                            cy={
                                Y
                            }
                            r={
                                9
                            }
                            fill={
                                done
                                    ? OK
                                    : MARK
                            }
                            stroke="#FFFFFF"
                            strokeWidth={
                                2
                            }
                        />


                        {
                            done && (

                                <foreignObject
                                    x={
                                        toX(
                                            marca
                                        ) -
                                        60
                                    }
                                    y={
                                        Y +
                                        46
                                    }
                                    width={
                                        120
                                    }
                                    height={
                                        70
                                    }
                                >

                                    <div
                                        style={{
                                            display:
                                                'flex',

                                            justifyContent:
                                                'center'
                                        }}
                                    >

                                        <Numero
                                            {...valorMostrar}
                                            size={
                                                30
                                            }
                                        />

                                    </div>

                                </foreignObject>
                            )
                        }

                    </g>
                )
            }

        </svg>
    );
};


// ============================================================================
// ESTADO INICIAL
// ============================================================================

const estadoInicial = () => ({

    etapa:
        0,

    hecho:
        false,

    // BANDEJAS PRINCIPALES
    B:
        0,

    p:
        1,

    pint:
        [],

    // RESPUESTA
    ent:
        null,

    num:
        null,

    den:
        null,

    // RECTA
    B3:
        0,

    p3:
        1,

    pint3:
        [],

    mark:
        null
});


// ============================================================================
// M155
// ============================================================================

const M155 = () => {


    const dispatch =
        useDispatch();


    const navigate =
        useNavigate();


    const [config] =
        useConfigAuth();


    // =========================================================================
    // REDUX
    // =========================================================================

    const iniciar =
        useSelector(
            state =>
                state.ejercicio.iniciar
        );


    const finalizar =
        useSelector(
            state =>
                state.ejercicio.finalizar
        );


    const id_paciente =
        useSelector(
            state =>
                state.usuario.id_paciente
        );


    const sesion =
        useSelector(
            state =>
                state.ejercicio.sesion
        );


    // =========================================================================
    // EJERCICIOS
    // =========================================================================

    const [
        ejercicios,
        setEjercicios
    ] = useState([]);


    const [
        count,
        setCount
    ] = useState(0);


    const [
        st,
        setSt
    ] = useState(
        estadoInicial
    );


    // =========================================================================
    // FEEDBACK / ANIMACIONES
    // =========================================================================

    const [
        feedback,
        setFeedback
    ] = useState(null);


    const [
        disable,
        setDisable
    ] = useState(false);


    const [
        isIncorrect,
        setIsIncorrect
    ] = useState(false);


    const [
        isCorrect,
        setIsCorrect
    ] = useState(false);


    // =========================================================================
    // ERRORES
    // =========================================================================

    const [
        contarErrores,
        setContarErrores
    ] = useState(0);


    const [
        erroresItemActual,
        setErroresItemActual
    ] = useState(0);


    const [
        erroresOrden,
        setErroresOrden
    ] = useState([]);


    // =========================================================================
    // ESTÍMULOS REALIZADOS
    // =========================================================================

    const [
        respuestasOrden,
        setRespuestasOrden
    ] = useState([]);


    // =========================================================================
    // NÚMERO ACTUAL
    // =========================================================================

    const numeroActual =
        ejercicios.length > 0

            ? ejercicios[
                count
            ]

            : null;


    const D =
        numeroActual
            ? numeroActual.den
            : 1;


    const T =
        numeroActual
            ? numeroActual.num
            : 0;


    const E =
        Math.floor(
            T /
            D
        );


    const R =
        T %
        D;


    const aMixto =
        numeroActual
            ? numeroActual.modo === 'a_mixto'
            : false;


    // Lo que mostramos como estímulo.
    const dado =
        aMixto

            ? {
                e:
                    0,

                num:
                    T,

                den:
                    D
            }

            : {
                e:
                    E,

                num:
                    R,

                den:
                    D
            };


    // Conversión canónica.
    const otro =
        aMixto

            ? {
                e:
                    E,

                num:
                    R,

                den:
                    D
            }

            : {
                e:
                    0,

                num:
                    T,

                den:
                    D
            };


    const valor =
        T /
        D;


    const limiteRecta =
        Math.max(
            3,
            Math.min(
                6,
                Math.ceil(
                    valor
                ) +
                1
            )
        );


    const mostrarEquivalencia =
        st.etapa === 2 ||
        (
            st.etapa === 1 &&
            st.hecho
        );


    // =========================================================================
    // TEXTO PARA GUARDAR
    // =========================================================================

    const textoEstimulo = () => {

        if (
            aMixto
        ) {

            return (
                `${T}/${D}`
            );
        }


        return (
            `${E} y ${R}/${D}`
        );
    };


    // =========================================================================
    // SONIDOS
    // =========================================================================

    const GoodWork = () => {

        new Audio(
            '/sounds/sonido_bien.mp3'
        ).play();
    };


    const TryAgain = () => {

        new Audio(
            '/sounds/sonidoMal.mp3'
        ).play();
    };


    // =========================================================================
    // ACTUALIZACIÓN DE ESTADO
    // =========================================================================

    const actualizar = (
        callback
    ) => {

        setSt(
            anterior => {

                const cambios =
                    typeof callback === 'function'

                        ? callback(
                            anterior
                        )

                        : callback;


                return {

                    ...anterior,

                    ...cambios
                };
            }
        );


        setFeedback(
            null
        );
    };


    // =========================================================================
    // ERROR
    //
    // Shake + sonido + bloqueo 300 ms.
    // No cambia de etapa.
    // =========================================================================

    const marcarError = (
        texto
    ) => {

        setContarErrores(
            errores =>
                errores + 1
        );


        setErroresItemActual(
            errores =>
                errores + 1
        );


        setFeedback({

            ok:
                false,

            text:
                texto
        });


        setDisable(
            true
        );


        setIsIncorrect(
            true
        );


        TryAgain();


        setTimeout(() => {

            setIsIncorrect(
                false
            );


            setDisable(
                false
            );

        }, 300);
    };


    // =========================================================================
    // BANDEJAS - ETAPA 1
    // =========================================================================

    const ponerBandeja = () => {

        if (
            disable ||
            st.hecho ||
            st.etapa !== 0
        ) {

            return;
        }


        actualizar(
            anterior => {

                if (
                    anterior.B >= 6
                ) {

                    return {};
                }


                return {

                    B:
                        anterior.B + 1,

                    pint: [
                        ...anterior.pint,

                        ...Array(
                            anterior.p
                        ).fill(
                            false
                        )
                    ]
                };
            }
        );
    };


    const sacarBandeja = () => {

        if (
            disable ||
            st.hecho ||
            st.etapa !== 0
        ) {

            return;
        }


        actualizar(
            anterior => {

                if (
                    anterior.B <= 0
                ) {

                    return {};
                }


                const nuevaCantidad =
                    anterior.B - 1;


                return {

                    B:
                        nuevaCantidad,

                    pint:
                        anterior.pint.slice(
                            0,
                            nuevaCantidad *
                            anterior.p
                        )
                };
            }
        );
    };


    const partir = (
        partes
    ) => {

        if (
            disable ||
            st.hecho ||
            st.etapa !== 0
        ) {

            return;
        }


        actualizar(
            anterior => ({

                p:
                    partes,

                pint:
                    Array(
                        anterior.B *
                        partes
                    ).fill(
                        false
                    )
            })
        );
    };


    const pintar = (
        bandeja,
        parte
    ) => {

        if (
            disable ||
            st.hecho ||
            st.etapa !== 0
        ) {

            return;
        }


        actualizar(
            anterior => {

                const posicion =
                    bandeja *
                    anterior.p +
                    parte;


                return {

                    pint:
                        anterior.pint.map(
                            (
                                valorActual,
                                index
                            ) =>

                                index === posicion

                                    ? !valorActual
                                    : valorActual
                        )
                };
            }
        );
    };


    // =========================================================================
    // RECTA
    // =========================================================================

    const ponerBandejaRecta = () => {

        if (
            disable ||
            st.hecho ||
            st.etapa !== 2
        ) {

            return;
        }


        actualizar(
            anterior => {

                if (
                    anterior.B3 >=
                    limiteRecta
                ) {

                    return {};
                }


                return {

                    B3:
                        anterior.B3 + 1,

                    pint3: [
                        ...anterior.pint3,

                        ...Array(
                            anterior.p3
                        ).fill(
                            false
                        )
                    ]
                };
            }
        );
    };


    const sacarBandejaRecta = () => {

        if (
            disable ||
            st.hecho ||
            st.etapa !== 2
        ) {

            return;
        }


        actualizar(
            anterior => {

                if (
                    anterior.B3 <= 0
                ) {

                    return {};
                }


                const nuevaCantidad =
                    anterior.B3 - 1;


                return {

                    B3:
                        nuevaCantidad,

                    pint3:
                        anterior.pint3.slice(
                            0,
                            nuevaCantidad *
                            anterior.p3
                        )
                };
            }
        );
    };


    const partirRecta = (
        partes
    ) => {

        if (
            disable ||
            st.hecho ||
            st.etapa !== 2
        ) {

            return;
        }


        actualizar(
            anterior => ({

                p3:
                    partes,

                pint3:
                    Array(
                        anterior.B3 *
                        partes
                    ).fill(
                        false
                    )
            })
        );
    };


    const pintarRecta = (
        bandeja,
        parte
    ) => {

        if (
            disable ||
            st.hecho ||
            st.etapa !== 2
        ) {

            return;
        }


        actualizar(
            anterior => {

                const posicion =
                    bandeja *
                    anterior.p3 +
                    parte;


                return {

                    pint3:
                        anterior.pint3.map(
                            (
                                valorActual,
                                index
                            ) =>

                                index === posicion

                                    ? !valorActual
                                    : valorActual
                        )
                };
            }
        );
    };


    const marcarRecta = (
        numero
    ) => {

        if (
            disable ||
            st.hecho ||
            st.etapa !== 2
        ) {

            return;
        }


        actualizar(
            anterior => {

                let marca =
                    Math.round(
                        numero *
                        100
                    ) /
                    100;


                if (
                    anterior.B3 > 0 &&
                    anterior.p3 > 1
                ) {

                    const paso =
                        Math.round(
                            numero *
                            anterior.p3
                        ) /
                        anterior.p3;


                    if (
                        Math.abs(
                            paso -
                            numero
                        ) <
                        0.07
                    ) {

                        marca =
                            paso;
                    }
                }


                return {

                    mark:
                        marca
                };
            }
        );
    };


    // =========================================================================
    // CORRECTO
    //
    // Zoom + sonido + bloqueo 300 ms.
    // Después avanza automáticamente.
    // =========================================================================

    const etapaCorrecta = (
        texto
    ) => {

        const etapaActual =
            st.etapa;


        setDisable(
            true
        );


        setIsCorrect(
            true
        );


        setSt(
            anterior => ({

                ...anterior,

                hecho:
                    true
            })
        );


        setFeedback({

            ok:
                true,

            text:
                texto
        });


        GoodWork();


        setTimeout(() => {


            setIsCorrect(
                false
            );


            // =================================================================
            // SIGUIENTE ETAPA DEL MISMO NÚMERO
            // =================================================================

            if (
                etapaActual < 2
            ) {

                setSt(
                    anterior => ({

                        ...anterior,

                        etapa:
                            etapaActual + 1,

                        hecho:
                            false
                    })
                );


                setFeedback(
                    null
                );


                setDisable(
                    false
                );


                return;
            }


            // =================================================================
            // TERMINÓ EL NÚMERO
            // =================================================================

            const nuevaLista = [

                ...respuestasOrden,

                textoEstimulo()

            ];


            const nuevosErrores = [

                ...erroresOrden,

                erroresItemActual

            ];


            setRespuestasOrden(
                nuevaLista
            );


            setErroresOrden(
                nuevosErrores
            );


            // =================================================================
            // SIGUIENTE NÚMERO
            // =================================================================

            if (
                count <
                ejercicios.length - 1
            ) {

                setCount(
                    anterior =>
                        anterior + 1
                );


                setSt(
                    estadoInicial()
                );


                setErroresItemActual(
                    0
                );


                setFeedback(
                    null
                );


                setDisable(
                    false
                );


                return;
            }


            // =================================================================
            // TERMINÓ M155
            // =================================================================

            setFeedback(
                null
            );


            setTimeout(() => {

                dispatch(
                    finalizarEjercicioAction()
                );

            }, 50);


        }, 300);
    };


    // =========================================================================
    // COMPROBAR
    // =========================================================================

    const comprobar = () => {

        if (
            disable ||
            st.hecho ||
            !numeroActual
        ) {

            return;
        }


        // =====================================================================
        // ETAPA 1
        // BANDEJAS
        // =====================================================================

        if (
            st.etapa === 0
        ) {

            if (
                st.B === 0
            ) {

                marcarError(
                    'Primero poné bandejas. Cada bandeja representa un entero.'
                );

                return;
            }


            if (
                st.p !== D
            ) {

                marcarError(
                    `Mirá el número de abajo: cada entero tiene que estar partido en ${D}.`
                );

                return;
            }


            const pintadas =
                st.pint.filter(
                    Boolean
                ).length;


            if (
                pintadas === T
            ) {

                etapaCorrecta(
                    `¡Muy bien! Representaste ${T}/${D}.`
                );

                return;
            }


            if (
                st.B *
                D <
                T
            ) {

                marcarError(
                    'No te alcanzan las bandejas. Poné otra.'
                );

                return;
            }


            if (
                pintadas >
                T
            ) {

                marcarError(
                    'Pintaste de más. Contá otra vez.'
                );

                return;
            }


            marcarError(
                'Te falta pintar.'
            );


            return;
        }


        // =====================================================================
        // ETAPA 2
        // CONVERSIÓN
        // =====================================================================

        if (
            st.etapa === 1
        ) {

            const {
                ent,
                num,
                den
            } = st;


            if (
                num === null ||
                den === null ||
                (
                    aMixto &&
                    ent === null
                )
            ) {

                marcarError(
                    'Completá todos los casilleros.'
                );

                return;
            }


            const entero =
                ent ??
                0;


            const igual =
                (
                    entero *
                    den +
                    num
                ) *
                D ===
                T *
                den;


            // =================================================================
            // IMPROPIA → MIXTO
            // =================================================================

            if (
                aMixto
            ) {

                if (
                    igual &&
                    entero === E &&
                    num < den
                ) {

                    etapaCorrecta(
                        `¡Muy bien! ${T}/${D} es lo mismo que ${E} y ${R}/${D}.`
                    );

                    return;
                }


                if (
                    igual &&
                    entero === 0
                ) {

                    marcarError(
                        'Esa sigue siendo una fracción. Escribila usando enteros.'
                    );

                    return;
                }


                if (
                    den !== D
                ) {

                    marcarError(
                        `Mirá el número de abajo: cada entero está partido en ${D}.`
                    );

                    return;
                }


                if (
                    entero !== E
                ) {

                    marcarError(
                        'Contá cuántas bandejas están pintadas completas.'
                    );

                    return;
                }


                marcarError(
                    'Ahora contá las partes pintadas de la bandeja que no está completa.'
                );


                return;
            }


            // =================================================================
            // MIXTO → FRACCIÓN
            // =================================================================

            if (
                igual &&
                entero === 0
            ) {

                etapaCorrecta(
                    `¡Muy bien! ${E} y ${R}/${D} es lo mismo que ${T}/${D}.`
                );

                return;
            }


            if (
                den !== D
            ) {

                marcarError(
                    `El número de abajo no cambia: cada entero está partido en ${D}.`
                );

                return;
            }


            marcarError(
                'Contá todas las partes pintadas, también las de los enteros completos.'
            );


            return;
        }


        // =====================================================================
        // ETAPA 3
        // RECTA
        // =====================================================================

        if (
            st.mark === null
        ) {

            marcarError(
                'Hacé clic en la recta donde va el número.'
            );

            return;
        }


        if (
            Math.abs(
                st.mark -
                valor
            ) <
            0.05
        ) {

            etapaCorrecta(
                '¡Excelente! Lo ubicaste en la recta numérica.'
            );

            return;
        }


        marcarError(

            (
                st.mark >
                valor

                    ? 'Te pasaste.'
                    : 'Te quedaste corto.'
            ) +

            (
                st.B3 > 0

                    ? ''
                    : ' Podés usar las bandejas para ayudarte.'
            )
        );
    };


    // =========================================================================
    // PLAY
    //
    // SOLAMENTE COMPRUEBA.
    // NUNCA AVANZA MANUALMENTE.
    // =========================================================================

    const verificar = (
        e
    ) => {

        e.preventDefault();


        if (
            disable ||
            st.hecho
        ) {

            return;
        }


        comprobar();
    };


    // =========================================================================
    // INICIALIZAR
    // =========================================================================

    useEffect(() => {

        const seleccion =
            seleccionarEjercicios();


        setEjercicios(
            seleccion
        );


        setCount(
            0
        );


        setSt(
            estadoInicial()
        );


        dispatch(
            setearEjercicioAction(
                'M155'
            )
        );


        dispatch(
            setearUrlAnteriorAction(
                'matematica/fracciones/'
            )
        );


        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    // =========================================================================
    // GUARDAR
    // =========================================================================

    useEffect(() => {

        if (
            !finalizar
        ) {

            return;
        }


        const informacion = {

            config,

            payload: {

                ejercicio:
                    'M155',

                errores:
                    contarErrores,

                lista_usada:
                    respuestasOrden,

                erroresOrden,

                id_paciente,

                sesion
            }
        };


        dispatch(
            almacenarAction(
                informacion
            )
        );


        navigate(
            '/escritorio/metodos/finalizar-ejercicio'
        );


        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [finalizar]);


    // =========================================================================
    // INSTRUCCIONES
    // =========================================================================

    if (
        !iniciar
    ) {

        return (

            <Fragment>

                <HeaderEjercicios
                    estrellas={
                        true
                    }
                    carrito={
                        true
                    }
                    minMay={
                        false
                    }
                />


                <Instrucciones
                    miniInstrucciones={
                        miniInstrucciones
                    }
                />

            </Fragment>
        );
    }


    if (
        !numeroActual
    ) {

        return null;
    }


    // =========================================================================
    // RENDER
    // =========================================================================

    return (

        <PantallaM155>


            <HeaderEjercicios
                estrellas={
                    true
                }
                carrito={
                    true
                }
                minMay={
                    false
                }
            />


            <ContenidoM155>


                <ContainerFlex
                    height="100%"
                    width="100%"
                    display="flex"
                    direction="column"
                    justify="center"
                    align="center"
                    isCorrect={
                        isCorrect
                    }
                    isIncorrect={
                        isIncorrect
                    }
                    $mantengoMay={
                        true
                    }
                >


                    <ZonaTrabajoM155>


                        {/* ================================================= */}
                        {/* NÚMERO OBJETIVO                                   */}
                        {/* ================================================= */}

                        <NumeroObjetivoM155>


                            <p>
                                {
                                    aMixto
                                        ? 'Convertí:'
                                        : 'Convertí:'
                                }
                            </p>


                            <Numero
                                {...dado}
                                size={
                                    105
                                }
                            />


                            {
                                mostrarEquivalencia && (

                                    <div
                                        className="equivalencia-m155"
                                    >

                                        <span>
                                            =
                                        </span>


                                        <Numero
                                            {...otro}
                                            size={
                                                58
                                            }
                                            color={
                                                OK
                                            }
                                        />

                                    </div>
                                )
                            }


                        </NumeroObjetivoM155>


                        {/* ================================================= */}
                        {/* ACTIVIDAD                                         */}
                        {/* ================================================= */}

                        <ActividadM155>


                            {/* ============================================= */}
                            {/* ETAPA 1 - BANDEJAS                            */}
                            {/* ============================================= */}

                            {
                                st.etapa === 0 && (

                                    <>

                                        <p
                                            className="consigna-m155"
                                        >
                                            Representá el número con bandejas.
                                        </p>


                                        <div
                                            className="botones-m155"
                                        >

                                            <button
                                                type="button"
                                                style={{
                                                    ...boton,

                                                    opacity:
                                                        disable ||
                                                        st.hecho

                                                            ? 0.5
                                                            : 1
                                                }}
                                                disabled={
                                                    disable ||
                                                    st.hecho
                                                }
                                                onClick={
                                                    ponerBandeja
                                                }
                                            >
                                                Poner bandeja
                                            </button>


                                            {
                                                st.B > 0 && (

                                                    <button
                                                        type="button"
                                                        style={{
                                                            ...boton,

                                                            borderColor:
                                                                MARK,

                                                            color:
                                                                MARK,

                                                            opacity:
                                                                disable ||
                                                                st.hecho

                                                                    ? 0.5
                                                                    : 1
                                                        }}
                                                        disabled={
                                                            disable ||
                                                            st.hecho
                                                        }
                                                        onClick={
                                                            sacarBandeja
                                                        }
                                                    >
                                                        Sacar bandeja
                                                    </button>
                                                )
                                            }

                                        </div>


                                        <EscenaM155>

                                            <Bandejas
                                                cantidad={
                                                    st.B
                                                }
                                                partes={
                                                    st.p
                                                }
                                                pintadas={
                                                    st.pint
                                                }
                                                onTocar={
                                                    pintar
                                                }
                                                activo={
                                                    !disable &&
                                                    !st.hecho
                                                }
                                            />

                                        </EscenaM155>


                                        {
                                            st.B > 0 && (

                                                <>

                                                    <Partir
                                                        valor={
                                                            st.p
                                                        }
                                                        onCambio={
                                                            partir
                                                        }
                                                        disabled={
                                                            disable ||
                                                            st.hecho
                                                        }
                                                        texto="Partir cada bandeja en:"
                                                    />


                                                    <p
                                                        className="ayuda-m155"
                                                    >
                                                        Pintá la cantidad que muestra el número.
                                                    </p>

                                                </>
                                            )
                                        }

                                    </>
                                )
                            }


                            {/* ============================================= */}
                            {/* ETAPA 2 - CONVERSIÓN                          */}
                            {/* ============================================= */}

                            {
                                st.etapa === 1 && (

                                    <>

                                        <p
                                            className="consigna-m155"
                                        >
                                            {
                                                aMixto

                                                    ? 'Ahora escribilo usando enteros.'

                                                    : 'Ahora escribilo como una sola fracción.'
                                            }
                                        </p>


                                        <EscenaM155
                                            $conversion={
                                                true
                                            }
                                        >

                                            <Bandejas
                                                cantidad={
                                                    st.B
                                                }
                                                partes={
                                                    st.p
                                                }
                                                pintadas={
                                                    st.pint
                                                }
                                                onTocar={() => {}}
                                                activo={
                                                    false
                                                }
                                            />

                                        </EscenaM155>


                                        <div
                                            className="respuesta-m155"
                                        >


                                            {
                                                aMixto && (

                                                    <Contador
                                                        valor={
                                                            st.ent
                                                        }
                                                        onCambio={
                                                            valorNuevo =>
                                                                actualizar({
                                                                    ent:
                                                                        valorNuevo
                                                                })
                                                        }
                                                        min={
                                                            0
                                                        }
                                                        disabled={
                                                            disable ||
                                                            st.hecho
                                                        }
                                                        etiqueta="enteros"
                                                        vertical={
                                                            true
                                                        }
                                                    />
                                                )
                                            }


                                            <div
                                                className="fraccion-m155"
                                            >

                                                <Contador
                                                    valor={
                                                        st.num
                                                    }
                                                    onCambio={
                                                        valorNuevo =>
                                                            actualizar({
                                                                num:
                                                                    valorNuevo
                                                            })
                                                    }
                                                    min={
                                                        0
                                                    }
                                                    disabled={
                                                        disable ||
                                                        st.hecho
                                                    }
                                                    etiqueta="numerador"
                                                />


                                                <div
                                                    className="linea-fraccion-m155"
                                                />


                                                <Contador
                                                    valor={
                                                        st.den
                                                    }
                                                    onCambio={
                                                        valorNuevo =>
                                                            actualizar({
                                                                den:
                                                                    valorNuevo
                                                            })
                                                    }
                                                    min={
                                                        1
                                                    }
                                                    disabled={
                                                        disable ||
                                                        st.hecho
                                                    }
                                                    etiqueta="denominador"
                                                />

                                            </div>


                                        </div>

                                    </>
                                )
                            }


                            {/* ============================================= */}
                            {/* ETAPA 3 - RECTA                               */}
                            {/* ============================================= */}

                            {
                                st.etapa === 2 && (

                                    <>

                                        <p
                                            className="consigna-m155"
                                        >
                                            Ubicá el número en la recta numérica.
                                        </p>


                                        <EscenaM155
                                            $recta={
                                                true
                                            }
                                        >

                                            <Recta
                                                limite={
                                                    limiteRecta
                                                }
                                                cantidadBandejas={
                                                    st.B3
                                                }
                                                partes={
                                                    st.p3
                                                }
                                                pintadas={
                                                    st.pint3
                                                }
                                                marca={
                                                    st.mark
                                                }
                                                onTocarParte={
                                                    pintarRecta
                                                }
                                                onClicRecta={
                                                    marcarRecta
                                                }
                                                done={
                                                    disable ||
                                                    st.hecho
                                                }
                                                valorMostrar={
                                                    aMixto
                                                        ? otro
                                                        : dado
                                                }
                                            />

                                        </EscenaM155>


                                        <div
                                            className="botones-m155"
                                        >

                                            <button
                                                type="button"
                                                style={{
                                                    ...boton,

                                                    opacity:
                                                        disable ||
                                                        st.hecho

                                                            ? 0.5
                                                            : 1
                                                }}
                                                disabled={
                                                    disable ||
                                                    st.hecho
                                                }
                                                onClick={
                                                    ponerBandejaRecta
                                                }
                                            >
                                                {
                                                    st.B3 === 0

                                                        ? 'Usar bandejas'
                                                        : 'Poner bandeja'
                                                }
                                            </button>


                                            {
                                                st.B3 > 0 && (

                                                    <button
                                                        type="button"
                                                        style={{
                                                            ...boton,

                                                            borderColor:
                                                                MARK,

                                                            color:
                                                                MARK,

                                                            opacity:
                                                                disable ||
                                                                st.hecho

                                                                    ? 0.5
                                                                    : 1
                                                        }}
                                                        disabled={
                                                            disable ||
                                                            st.hecho
                                                        }
                                                        onClick={
                                                            sacarBandejaRecta
                                                        }
                                                    >
                                                        Sacar bandeja
                                                    </button>
                                                )
                                            }

                                        </div>


                                        {
                                            st.B3 > 0 && (

                                                <Partir
                                                    valor={
                                                        st.p3
                                                    }
                                                    onCambio={
                                                        partirRecta
                                                    }
                                                    disabled={
                                                        disable ||
                                                        st.hecho
                                                    }
                                                    texto="Partir cada bandeja en:"
                                                />
                                            )
                                        }

                                    </>
                                )
                            }


                            {/* ============================================= */}
                            {/* FEEDBACK                                      */}
                            {/* ============================================= */}

                            <p
                                className={
                                    feedback

                                        ? feedback.ok

                                            ? 'feedback-m155 ok'
                                            : 'feedback-m155 error'

                                        : 'feedback-m155'
                                }
                            >
                                {
                                    feedback

                                        ? feedback.text
                                        : '.'
                                }
                            </p>


                        </ActividadM155>


                    </ZonaTrabajoM155>


                </ContainerFlex>


            </ContenidoM155>


            {/* ============================================================= */}
            {/* BOTTOM                                                        */}
            {/* ============================================================= */}

            <BottomM155>


                <BotoneraBottom
                    miniInstrucciones={
                        miniInstrucciones
                    }
                />


                <AvanzarBtn
                    disabled={
                        disable ||
                        st.hecho
                    }
                    onClick={
                        verificar
                    }
                >

                    <AvanzarImg
                        src="/img/play.png"
                    />

                </AvanzarBtn>


            </BottomM155>


        </PantallaM155>
    );
};


export default M155;